import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { generateNanoId } from "@shared/utils";
import { TRACE_ID_HEADER, UI_VERSION_HEADER } from "@shared/constants";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SetHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const traceId = `patient-${generateNanoId()}`;
    const setHeaders = { "Content-Type": "application/json", [TRACE_ID_HEADER]: traceId, [UI_VERSION_HEADER]: environment.VERSION };
    const authReq = req.clone({ setHeaders });
    return next.handle(authReq);
  }
}
